import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import { store } from "src/store";

import { Loader } from "./loader";

const App: React.FC = () => {
  return (
    <Provider store={store.store}>
      <PersistGate persistor={store.persistor}>
        {(bootsrapped) => <Loader bootsrapped={bootsrapped} />}
      </PersistGate>

      <ToastContainer
        position="top-right"
        className="anten-toast top"
        pauseOnFocusLoss={false}
        hideProgressBar
        closeButton={false}
      />
    </Provider>
  );
};

export default App;
